export default "__VITE_ASSET__C2RQWC7x__"